import React from "react";

const Checked = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16-7.163 16-16 16zm-1.595-9.6l11.312-11.314-2.263-2.262-9.05 9.051-4.526-4.526-2.262 2.262 6.789 6.789z"
            fill={fill}
        />
    </svg>
);

export default Checked;
